import React from 'react';
import classNames from 'classnames';
import { Button, Switch } from 'src/components-dummy';
import { getRuleSummaryText } from './helpers';
import { MerchRuleRow } from './types';

export interface RuleRowProps {
  row: MerchRuleRow;
  onToggleActive: (row: MerchRuleRow, active: boolean) => void;
  onEdit: (row: MerchRuleRow) => void;
}

const CHANGE_LABEL: Record<MerchRuleRow['state'], string> = {
  unchanged: '—',
  edited: 'Edited',
  disabled: 'Off',
};

export const RuleRow = ({ row, onToggleActive, onEdit }: RuleRowProps): JSX.Element => {
  const { control, test, state } = row;
  const isActive = test?.active ?? control.active;
  const summaryText =
    state === 'edited' && test ? getRuleSummaryText(test) : getRuleSummaryText(control);

  return (
    <tr className={classNames('syte-merch-rule-row', `syte-merch-rule-row-${state}`)}>
      <td>
        <div className='syte-merch-rule-row-name'>{control.name}</div>
        <div className='syte-merch-rule-row-summary'>{summaryText}</div>
      </td>
      <td className='syte-merch-rule-row-control'>{control.active ? 'Active' : 'Inactive'}</td>
      <td>
        <div className='syte-merch-rule-row-variant'>
          <Switch checked={isActive} onChange={active => onToggleActive(row, active)} />
          <Button variant='tertiary' disabled={!isActive} onClick={() => onEdit(row)}>
            {state === 'edited' ? 'Edited' : 'Edit'}
          </Button>
        </div>
      </td>
      <td
        className={classNames('syte-merch-rule-row-change', {
          'syte-merch-rule-row-change-amber': state !== 'unchanged',
        })}
      >
        {CHANGE_LABEL[state]}
      </td>
    </tr>
  );
};
